import React, { useEffect, useState } from "react";
import ToastNotification from '../../../components/ToastNotification';
import { useNavigate } from 'react-router-dom';
import { FaRegEye } from "react-icons/fa";
import { MdOutlineVerifiedUser } from "react-icons/md";
import Select, { components } from 'react-select';
import { BsPeopleFill } from "react-icons/bs";
import { CiViewList } from "react-icons/ci";
import axios from "axios";
import socket from "../../../socket";
import { PiPhoneCallFill } from "react-icons/pi";
import { BiSolidEditAlt } from "react-icons/bi";
import { MdDeleteForever } from "react-icons/md";
import ConfirmDialog from '../../../components/ConfirmDialog';
import { AiTwotoneEdit } from "react-icons/ai";
import { GrDocumentVerified } from "react-icons/gr";


function TelleCaller({ adminData }) {
    const navigate = useNavigate();
    const [toast, setToast] = useState({
        show: false,
        message: '',
        bg: 'success'
    });

    const [formItems, setFormItems] = useState({
        id: "",
        holder_name: "",
        code: "",
        party_mobile: "",
        party_email: "",
        party_birth_day: "",
        party_region: "",
        party_address: "",
        op_bal: "",
        budget: "",
        days: "",
        type_account: "",
        parent: "",
        remark: '',
    });

    const showToast = (message, bg = 'success') => {
        setToast({ show: true, message, bg });
    };
       const [confirmDialog, setConfirmDialog] = useState({
                show: false,
                title: '',
                message: '',
                onConfirm: null,
            });
        
    
        const showConfirmDialog = ({ title, message, onConfirm }) => {
            setConfirmDialog({
                show: true,
                title,
                message,
                onConfirm: () => {
                    onConfirm();
                    setConfirmDialog({ ...confirmDialog, show: false });
                },
            });
        };

    const [detail, setDetail] = useState([]);
    const [showVerifyModal, setShowVerifyModal] = useState(false);
    const [step, setStep] = useState(1);
    const [selectedEmployee, setSelectedEmployee] = useState(null);
    const [user, setUser] = useState([]);
    const [selectedCall, setSelectedCall] = useState(null);
    const [calls, setCalls] = useState([]);
    const [remark, setRemark] = useState("");
    const [showModal, setShowModal] = React.useState(false);
    const [selectedRemark, setSelectedRemark] = React.useState("");
    const [partyDetail, setPartyDetail] = useState([]);
    const [editingCompanyId, setEditingCompanyId] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editingId, setEditingId] = useState(null);
const [editForm, setEditForm] = useState({});


    useEffect(() => {
  if (!adminData.user.emp_id) return;

  socket.on("connect", () => {
    socket.emit("register-user", adminData.user.emp_id);

  });

  // If already connected
  if (socket.connected) {
    socket.emit("register-user", adminData.user.emp_id);
   
  }

  return () => {
    socket.off("connect");
  };
}, [adminData.user.emp_id]);

useEffect(() => {
  const handleMaterial = (data) => {
   
    showToast(data.message, "info");
  };

  socket.on("new-assigned-call", handleMaterial);

  return () => {
    socket.off("new-assigned-call", handleMaterial);
  };
}, []);

    const options = user.map(t => ({
        value: t.id,
        label: `${t.first} ${t.middle}  ${t.last} - ${t.emp_id}`
    }));



    const handleVerify = async () => {
        try {


            const payload = {
                call_id: selectedCall.id,
                remark: remark,
                data_type: "verified"
            };

            await axios.post("https://api.skyguard.group/api/verify-call", payload);

            showToast("Call verified successfully!", "success");

            setShowVerifyModal(false);
            setSelectedEmployee(null);
            setSelectedCall(null);
            setRemark("");
            fetchCallDetail(adminData);
        } catch (error) {
            showToast("Verification failed!", "danger");
        }
    };
    const handleReject = async () => {
        try {
            if (!selectedCall?.id) {
                showToast("Please select a call", "danger");
                return;
            }

            const payload = {
                call_id: selectedCall.id,
                remark: remark,
                data_type: "rejected"
            };

            await axios.post("https://api.skyguard.group/api/update-data-sheet-call-status", payload);

            showToast("Call rejected successfully!", "warning");

            setShowVerifyModal(false);
            setSelectedCall(null);
            setRemark("");
            fetchCallDetail(adminData);

        } catch (error) {
            console.error(error);
            showToast("Failed to reject call!", "danger");
        }
    };




    const fectEmphDetail = async () => {
        try {
            const resEmployee = await axios.get('https://api.skyguard.group/api/fetch-employee');
            setUser(resEmployee.data.result);
        } catch (error) {
            console.log(error)
        }
    };




    const fetchCallDetail = async (adminData) => {
        try {
            let res;

            if (adminData.role === "admin") {

                res = await axios.get("https://api.skyguard.group/api/fetch-call-detail");

             
            } else {

                res = await axios.get("https://api.skyguard.group/api/fetch-call-detail-employee", {
                    params: { emp_id: adminData.user.id }
                });
            }

            const filteredData = res.data.filter(
                item => item.data_type === "assigned" || item.data_type === "verified" || item.data_type === 'reference'
            ).sort((a, b) => Number(b.id) - Number(a.id));

            setDetail(filteredData);
        } catch (error) {
            console.log(error);
        }
    };


    const fecthPartyDetail = async () => {
        try {
            const res = await axios.get('https://api.skyguard.group/api/fetch-party');
            const data = res.data;
            setPartyDetail(data);
    
        } catch (error) {
            console.log(error);
        }
    }



    useEffect(() => {
        if (adminData) {
            fetchCallDetail(adminData);
        }
    }, [adminData]);


    useEffect(() => {
        fectEmphDetail();
        fecthPartyDetail();

        const handleFocus = () => {
            fecthPartyDetail();
        };
        window.addEventListener('focus', handleFocus);
        return () => {
            window.removeEventListener('focus', handleFocus);
        };
    }, []);

    const handleEdit = (row) => {
   
    setEditingId(row.id);
    setEditForm({
        name: row.name,
        number: row.number,
        address: row.address,
        state: row.state,
        city: row.city,
        region: row.region,
        data_type: row.data_type,
        remark: row.remark,
        pincode:row.pincode,
    });
};


const handleEditChange = (field, value) => {
    setEditForm(prev => ({
        ...prev,
        [field]: value
    }));
};

const handleUpdate = async (id) => {
    try {
        await axios.put(
            `https://api.skyguard.group/api/update-call-data-sheet/${id}`,
            editForm
        );
        setEditingId(null);
        if (adminData) {
            fetchCallDetail(adminData);
        } else {
            fetchCallDetail();
        }
        fecthPartyDetail();

        showToast("Updated Successfully",'success');
    } catch (err) {
        console.error(err);
        showToast("Update failed",'danger');
    }
};

    const handleDelete = async (id) => {
        try {
            const response = await axios.delete(`https://api.skyguard.group/api/delete-call-data/${id}`)
            showToast('call data deleted successfully', 'success');
               fetchCallDetail();

        } catch (error) {
            console.error('Error deleting loan:', error);
            showToast('Failed to delete call data', 'danger');
        }
    }

    return (
        <div className='main-section'>

            <div className='container-fluid dashboard-wrapper p-3 bg-body-secondary'>

                <ToastNotification
                    show={toast.show}
                    message={toast.message}
                    bg={toast.bg}
                    onClose={() => setToast({ ...toast, show: false })}
                />
                <h3 className='my-3 fw-bold fs-5 golos'> Call List</h3>

                <div className='table-responsive shadow p-3 mb-5 bg-body-tertiary rounded my-4'>
                    <table className="table table-bordered table-striped text-center table-sm align-middle">
                        <thead className="table-info">
                            <tr>
                                <th>SN No</th>
                                  <th>Actions</th>
                                <th> Name</th>
                                <th>Phone</th>
                                <th>Address</th>
                           <th>State</th>
                           <th>City</th>
                           <th>Region</th>
                                <th>Status </th>
                                <th>Remark</th>

                            </tr>
                        </thead>
                        <tbody>
                           

                            {detail.map((p, i) => {
    const normalizePhone = value => String(value || '').replace(/\D/g, '');
    const pNumber = normalizePhone(p.number);
    const party = partyDetail.find(
        (pt) =>
            (p.name && pt.name && pt.name.trim().toLowerCase() === p.name.trim().toLowerCase()) ||
            (pNumber && [pt.phone, pt.mobile, pt.phone_two, pt.phone_three, pt.contact_no].some(v => normalizePhone(v) === pNumber))
    );

    return (
        <tr key={p.id}>
            <td>{detail.length - i}</td>
                <td>
                {p.data_type === 'verified' ? (
                  
                     <GrDocumentVerified title="Party Verified" 
                     className="text-success"
                     size={20}
                       disabled
                     />
                   
                ) : (
                    <MdOutlineVerifiedUser
                        size={26}
                        className="text-primary"
                        title="Verify"
                        onClick={() => {
                            setSelectedCall(p);
                            setStep(1);
                            setShowVerifyModal(true);
                        }}
                    />
                )}

               
                {p.data_type === 'verified' && party?.party_created === 1 && (
                    <button
                        className="btn btn-secondary btn-sm ms-2"
                        disabled
                        title="Party already created"
                    >
                        Party Created
                    </button>
                )}

      
                {p.data_type === 'verified' && party?.party_created !== 1 && (
                    <BsPeopleFill
                        size={26}
                        className="ms-2 text-dark"
                        title="Add Party"
                        onClick={() => {
                            navigate("/admin/party", {
                                state: {
                                    showAddForm: true,
                                    partyData: {
                                        party: p.name,
                                        site: p.address,
                                        mobile: p.number,
                                        state:p.state,
                                        city:p.city,
                                        region:p.region,
                                        pincode:p.pincode,
                                    }
                                }
                            });
                        }}
                    />
                )}


{editingId === p.id ? (
    <>
        <button
            className="btn btn-success btn-sm"
            onClick={() => handleUpdate(p.id)}
        >
            Update
        </button>

        <button
            className="btn btn-secondary btn-sm ms-2"
            onClick={() => setEditingId(null)}
        >
            Cancel
        </button>
    </>
) : p.data_type !== "verified" && party?.party_created !== 1 ? (
    <>
        <BiSolidEditAlt
            size={26}
            title="Edit Party Data"
            className="ms-2 text-primary"
            onClick={() => handleEdit(p)}
        />

        <MdDeleteForever
            size={20}
            className="text-danger"
            onClick={() =>
                showConfirmDialog({
                    title: "Delete Data",
                    message: `Are you sure you want to delete "${p.name}" from call list?`,
                    onConfirm: () => handleDelete(p.id),
                })
            }
        />
    </>
) : ""}

 {p.data_type === 'verified' && party?.party_created == 1 &&(
<PiPhoneCallFill size={26}
                        className="ms-2 text-dark"
                        title="Add Follow up"
                          onClick={() => {
                            const normalizePhone = value => String(value || '').replace(/\D/g, '');
                            const number = normalizePhone(p.number);
                            const exactId = p.party_id || p.partyId;

                            let selectedParty = null;

                            if (exactId) {
                                const idMatches = partyDetail.filter(pt => String(pt.id) === String(exactId));
                                if (idMatches.length === 1) {
                                    selectedParty = idMatches[0];
                                } else if (idMatches.length > 1) {
                                    showToast("Multiple parties found. Select exact party.", "danger");
                                    return;
                                } else {
                                    showToast('Please select this Party in CRM FollowUp; a unique Party could not be identified.', 'danger');
                                    return;
                                }
                            }

                            if (!selectedParty) {
                                const phoneMatches = number ? partyDetail.filter(pt =>
                                    [pt.phone, pt.mobile, pt.phone_two, pt.phone_three, pt.contact_no]
                                        .some(value => normalizePhone(value) === number)
                                ) : [];
                                const nameMatches = partyDetail.filter(pt =>
                                    pt.name && p.name && pt.name.trim().toLowerCase() === p.name.trim().toLowerCase()
                                );

                                const bothMatches = phoneMatches.filter(pt =>
                                    pt.name && p.name && pt.name.trim().toLowerCase() === p.name.trim().toLowerCase()
                                );

                                if (bothMatches.length === 1) {
                                    selectedParty = bothMatches[0];
                                } else if (bothMatches.length > 1) {
                                    showToast("Multiple parties found. Select exact party.", "danger");
                                    return;
                                } else if (phoneMatches.length === 1 && nameMatches.length === 0) {
                                    selectedParty = phoneMatches[0];
                                } else if (nameMatches.length === 1 && phoneMatches.length === 0) {
                                    selectedParty = nameMatches[0];
                                } else if (phoneMatches.length > 0 || nameMatches.length > 0) {
                                    showToast("Multiple parties found. Select exact party.", "danger");
                                    return;
                                }
                            }

                            if (!selectedParty?.id) {
                                showToast('Please select this Party in CRM FollowUp; a unique Party could not be identified.', 'danger');
                                return;
                            }
                            navigate("/admin/crm/followup", {
                                state: {
                                    showForm: true,
                                    partyData: {
                                        partyId: selectedParty.id,
                                        party: selectedParty.name || p.name,
                                        site: selectedParty.address || p.address,
                                        mobile: selectedParty.mobile || selectedParty.phone || p.number,
                                        state: selectedParty.state || p.state,
                                        city: selectedParty.city || p.city,
                                        region: selectedParty.region || p.region,
                                        pincode: selectedParty.pin || p.pincode,
                                    }
                                }
                            });
                        }}
                        />
 )}

            </td>
{/* 
            <td>{p.name}</td>
            <td>{p.number}</td>
          <td style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
  {p.address}
</td>
            <td>{p.data_type}</td>
            <td>
                <CiViewList
                    size={26}
                    className="text-primary"
                    title="View Remark"
                    onClick={() => setSelectedRemark(p.remark)}
                    data-bs-toggle="modal"
                    data-bs-target="#remarkModal"
                />
            </td> */}

               <td>
                            {editingId === p.id ? (
                                <input
                                    className="form-control"
                                    value={editForm.name}
                                    onChange={(e) =>
                                        handleEditChange("name", e.target.value)
                                    }
                                />
                            ) : (
                                p.name
                            )}
                        </td>
            
                        <td>
                            {editingId === p.id ? (
                                <input
                                    className="form-control"
                                    value={editForm.number}
                                    onChange={(e) =>
                                        handleEditChange("number", e.target.value)
                                    }
                                />
                            ) : (
                                <a href={`tel:${String(p.number ?? '').replace(/[^\d+]/g, '')}`}>
                                    {p.number}
                                </a>
                            )}
                        </td>
            
                        <td>
                            {editingId === p.id ? (
                                <input
                                    className="form-control"
                                    value={editForm.address}
                                    onChange={(e) =>
                                        handleEditChange("address", e.target.value)
                                    }
                                />
                            ) : (
                                p.address
                            )}
                        </td>
            
                        <td>
                            {editingId === p.id ? (
                                <input
                                    className="form-control"
                                    value={editForm.state}
                                    onChange={(e) =>
                                        handleEditChange("state", e.target.value)
                                    }
                                />
                            ) : (
                                p.state
                            )}
                        </td>
            
                        <td>
                            {editingId === p.id ? (
                                <input
                                    className="form-control"
                                    value={editForm.city}
                                    onChange={(e) =>
                                        handleEditChange("city", e.target.value)
                                    }
                                />
                            ) : (
                                p.city
                            )}
                        </td>
            
                        <td>
                            {editingId === p.id ? (
                                <input
                                    className="form-control"
                                    value={editForm.region}
                                    onChange={(e) =>
                                        handleEditChange("region", e.target.value)
                                    }
                                />
                            ) : (
                                p.region
                            )}
                        </td>
            
                        <td>
                            {editingId === p.id ? (
                                <input
                                    className="form-control"
                                    value={editForm.data_type}
                                    disabled
                                />
                            ) : (
                                p.data_type
                            )}
                        </td>
            
                        <td>
                            {editingId === p.id ? (
                                <input
                                    className="form-control"
                                    value={editForm.remark}
                                    onChange={(e) =>
                                        handleEditChange("remark", e.target.value)
                                    }
                                />
                            ) : (
                                <CiViewList
                                    size={26}
                                    className="text-primary"
                                    title="View Remark"
                                    onClick={() => setSelectedRemark(p.remark)}
                                    data-bs-toggle="modal"
                                    data-bs-target="#remarkModal"
                                />
                            )}
                        </td>
            


        </tr>
    );
})}

                        </tbody>

                    </table>
                </div>
                {showVerifyModal && (
                    <div className="modal fade show d-block" tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content border-0 shadow">

                                {/* HEADER */}
                                <div className="modal-header">
                                    <h5 className="modal-title">Verify / Reject Call</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowVerifyModal(false)}
                                    />
                                </div>

                                {/* BODY */}
                                <div className="modal-body text-center">

                                    <MdOutlineVerifiedUser
                                        size={40}
                                        className="text-primary mb-3"
                                    />

                                    <p className="mb-3">
                                        Are you sure you want to <strong>verify this call?</strong>
                                    </p>

                                    {/* REMARK */}
                                    <div className="text-start">
                                        <label className="form-label fw-medium">
                                            Remark <span className="text-muted">(optional)</span>
                                        </label>
                                        <textarea
                                            className="form-control"
                                            rows="3"
                                            placeholder="Enter remark..."
                                            value={remark}
                                            onChange={(e) => setRemark(e.target.value)}
                                        />
                                    </div>

                                </div>

                                {/* FOOTER */}
                                <div className="modal-footer justify-content-center">
                                    {/* Cancel Button */}
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => setShowVerifyModal(false)}
                                    >
                                        Cancel
                                    </button>

                                    {/* Reject Button */}
                                    <button
                                        className="btn btn-danger"
                                        onClick={handleReject}
                                    >
                                        Reject
                                    </button>

                                    {/* Verify Button */}
                                    <button
                                        className="btn btn-success"
                                        onClick={handleVerify}
                                    >
                                        Verify & Save
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                )}



                <div className="modal fade" id="remarkModal" tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">

                            <div className="modal-header">
                                <h5 className="modal-title text-primary">Remark</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                ></button>
                            </div>

                            <div className="modal-body">
                                {selectedRemark}
                            </div>

                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Cancel
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
  <ConfirmDialog
                show={confirmDialog.show}
                title={confirmDialog.title}
                message={confirmDialog.message}
                onConfirm={confirmDialog.onConfirm}
                onCancel={() => setConfirmDialog({ ...confirmDialog, show: false })}
            />
            </div>
        </div>
    )
}

export default TelleCaller
